export default function Officer(submissionId, changeId, entityId) {
  this.submissionID = submissionId
  this.changeID = changeId
  this.entityID = entityId
  this.officerID = null
  this.officerTitleID = 0
  this.officerName = ''
  this.title = ''
  this.officerPhone = ''
  this.interest = ''
  this.interestType = 0
}